import React, { useState } from 'react';
import CategoryNavigation from './CategoryNavigation';
import FeaturedContent from './FeaturedContent';
import LatestArticles from './LatestArticles';
import { articles, normalizeDate } from '../../types/Blog';
import { SearchBar } from './SearchBar';

const BlogContent: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  // Sort all articles by time (newest first)
  const sortedArticles = [...articles].sort((a, b) => {
    const timeA = new Date(`${normalizeDate(a.date)} ${a.time}`).getTime();
    const timeB = new Date(`${normalizeDate(b.date)} ${b.time}`).getTime();
    return timeB - timeA;
  });

  // Filter articles based on selected category
  const filteredArticles = selectedCategory
    ? sortedArticles.filter(article =>
      selectedCategory === 'All' ? true : article.category === selectedCategory
    )
    : sortedArticles;

  // Get featured article (first article in the sorted and filtered list)
  const featuredArticle = filteredArticles.length > 0 ? filteredArticles[0] : null;

  // Get read also articles (exclude the featured article)
  const readAlsoArticles = filteredArticles.slice(1, 5);

  return (
    <div className="mt-[2rem] w-full flex flex-col items-center">
      <h1 className='text-3xl md:text-4xl font-bold font-body text-center text-defaultBlue mb-8'>IIT Challenge News</h1>
      <div className='w-[80%] flex flex-col items-center'>
        <CategoryNavigation
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
        />
        <SearchBar />
      </div>

      {filteredArticles.length === 0 ? (
        <div className="text-center py-10">
          <h2 className="text-2xl font-bold mb-4">Tidak ada artikel dalam kategori ini</h2>
          <p className="text-gray-500">Silakan pilih kategori lain atau coba pencarian yang berbeda</p>
        </div>
      ) : (
        <>
          {featuredArticle && (
            <FeaturedContent
              featuredArticle={featuredArticle}
              readAlsoArticles={readAlsoArticles}
              hasArticles={filteredArticles.length > 0}
              selectedCategory={selectedCategory}
            />
          )}
          <div className=' pr-[10%] pl-[10%] w-full py-5 mt-5 -mb-5 bg-gradient-to-br from-defaultBlue via-[#63C8ED] to-cyan-300 relative overflow-hidden flex justify-center'>
            <LatestArticles
              articles={filteredArticles}
              selectedCategory={selectedCategory}
            />
            <img alt='' src='/images/CircleDotsWhite.svg' className='absolute  -top-16 -right-16 z-10 w-64 h-64 ' />
          </div>
        </>
      )}
    </div>

  );
};

export default BlogContent;